import { render, staticRenderFns } from "./FrzDistributionBoxesPallets.vue?vue&type=template&id=67456dd4"
import script from "./FrzDistributionBoxesPallets.vue?vue&type=script&lang=js"
export * from "./FrzDistributionBoxesPallets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports